import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import { DateRangePicker } from "react-dates";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import appcolors from "../../constants/Colors";
import "./style.css";
import moment from "moment";

function CustomRangePicker({
  stackProps,
  iconProps,
  rangeProps,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
}) {
  // const [startDate, setStartDate] = useState(null);
  // const [endDate, setEndDate] = useState(null);
  const [focusedInput, setFocusedInput] = useState(null);

  // useEffect(() => {
  //   const currentDate = moment();
  //   const priorDate = moment().subtract(1, "month");

  //   setStartDate(priorDate);
  //   setEndDate(currentDate);
  // }, []);

  const handleDatesChange = ({ startDate, endDate }) => {
    setStartDate(startDate);
    setEndDate(endDate);
  };

  const handleStackClick = () => {
    setFocusedInput(focusedInput || "startDate");
  };

  return (
    <Stack
      p={"8px"}
      gap={1}
      direction={"row"}
      alignItems={"center"}
      bgcolor={appcolors.white}
      onClick={handleStackClick}
      {...stackProps}
    >
      <CalendarMonthIcon
        htmlColor={appcolors.gunmetal}
        sx={{ fontSize: "1.1rem", ...iconProps }}
      />
      <DateRangePicker
        startDate={startDate}
        startDateId="your_start_date_id"
        endDate={endDate}
        endDateId="your_end_date_id"
        onDatesChange={handleDatesChange}
        focusedInput={focusedInput}
        onFocusChange={(focusedInput) => setFocusedInput(focusedInput)}
        noBorder
        hideKeyboardShortcutsPanel
        isOutsideRange={() => false}
        customArrowIcon={"-"}
        {...rangeProps}
      />
    </Stack>
  );
}

export default CustomRangePicker;
